import {all} from 'redux-saga/effects';
import logbookSagas from './logbookSaga';
import companySaga from "./companySaga";

export default function* rootSaga(getState) {
    yield all([
        logbookSagas(),
        companySaga()
    ])
}
